import {createMuiTheme, Theme} from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";

export default function getMuiTheme(impersonating: boolean): Theme {
  return createMuiTheme({
    palette: {
      primary: {
        main: impersonating ? "#56073e" : "#24405b",
      },
      secondary: {
        main: impersonating ? "#398ec1" : "#dc004e",
      },
      error: {
        main: red.A400,
      },
      background: {
        default: "#fff",
      },
    },
    props: {
      MuiButton: {
        variant: "outlined",
        color: "primary",
      },
      MuiTextField: {},
    },
  });
}
